import { render } from "./Section Stock.vue?vue&type=template&id=4e7615ac"
import script from "./Section Stock.vue?vue&type=script&lang=js"
export * from "./Section Stock.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__